<template>
  <v-data-table :items="items" hide-actions hide-headers>
    <template slot="items" slot-scope="props">
      <td><strong>{{ props.item.name }}</strong></td>
      <td>{{ props.item.value }}</td>
    </template>
  </v-data-table>
</template>

<script>
export default {
  props: {
    items: Array,
  },
};
</script>
